export default {
    home: {
        langNow: "แบบไทย",
        center: "ศูนย์เติมเงิน",
        saveTo: "เพิ่มไปยังหน้าจอหลัก",
        agreement: "ข้อตกลงผู้ใช้",
        privacy: "นโยบายความเป็นส่วนตัว",
        QuickAccess: "การเข้าถึงอย่างรวดเร็ว"
    },
    center: {
        dailyPack:"แพ็คเกจรายวันคุ้มค่า",
        dailyProgressionPack: "แพ็คเกจความคืบหน้าประจำวัน",
        account: "เลขที่บัญชีเติมเงิน",
        userId: "รหัสผู้ใช้:",
        regionId:"معرف:",
        region:"ภูมิภาค:",
        enterRegionId:"ใส่รหัสผู้ใช้",
        enterRegion:"ใส่ภูมิภาคผู้ใช้",
        nickname: "ชื่อเล่น:",
        enterId: "กรุณาใส่รหัสผู้ใช้ของคุณ",
        logIn: "เข้าสู่ระบบ",
        exist: "ไม่พบรหัสผู้ใช้ของคุณ",
        check: "กรุณาตรวจสอบรหัสผู้ใช้ของคุณ",
        empty: "รหัสผู้ใช้ของคุณไม่สามารถเว้นว่างได้",
        notLogin: "คุณยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบก่อนทำการซื้อ",
        method: "วิธีการชำระเงิน",
        amount: "ยอดเงินที่จะเติม",
        SelectItem: "เลือกรายการ",
        bonus: "รางวัล",
        welfare: "พิเศษ",
        dragon: "ความแข็งแรง",
        fairy: "อุปกรณ์",
        diamond: "เพชร",
        purchase: "ซื้อ",
        safari: "คำแนะนำอบอุ่น: กรุณาเปิดหน้านี้ด้วย Safari เบราว์เซอร์ หากคุณกำลังใช้งานอยู่แล้ว โปรดเพิกเฉย และดำเนินการชำระเงินต่อไป",
        about: "คำอธิบายการเติมเงิน",
        about1: "1. บัญชีที่เข้าสู่ระบบต้องตรงกับบัญชีที่เข้าเกมด้วย。",
        about2: "2. สำคัญ: หลังจากใส่บัญชีแล้ว กรุณาตรวจสอบข้อมูลบัญชีที่แสดงอย่างละเอียด และยืนยันว่าถูกต้องก่อนทำขั้นตอนต่อไป!",
        about3: "3. หลังจากเติมเงินสำเร็จ ระบบจะส่งสินค้าไปยังบัญชีเติมเงินของคุณ กรุณาตรวจสอบในเกม。",
        about4: "4. ข้อเสนอช่วงเวลา限定: ตั้งแต่ 1 พฤษภาคม เป็นต้นไป รับรางวัลเพิ่ม 10% เมื่อใช้ศูนย์เติมเงินในเว็บไซต์ทางการ",
        about5: "อีเมลฝ่ายบริการลูกค้า：",
        about6: "。",
        pay: "ชำระเงิน",
        price: "ราคา",
        total: "รวมทั้งหมด",
        save: "บันทึกข้อมูลบัตรเพื่อใช้ในการชำระเงินครั้งต่อไป",
        agree: "ฉันได้อ่านและยอมรับนโยบายความเป็นส่วนตัว",
        proceed: "ดำเนินการชำระเงินต่อ",
        cancel: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการชำระเงินนี้?",
        cancelPay: "ยกเลิก",
        continue: "ดำเนินการต่อ",
        success: "ชำระเงินสำเร็จ! สินค้าที่ซื้อได้ถูกส่งไปยังบัญชีเติมเงินของคุณแล้ว กรุณาตรวจสอบในเกม และเพื่อการเข้าถึงที่สะดวกและประสบการณ์ที่ดีขึ้น กรุณาเพิ่มเข้าไปที่หน้าจอหลัก",
        failed1: "การชำระเงินล้มเหลว กรุณาลองทำการซื้อใหม่",
        failed2: "หากล้มเหลวหลายครั้ง กรุณาคลิกที่บริการลูกค้าที่หน้าหลักหรือส่งอีเมลไปที่บริการลูกค้า",
        shopping: "ซื้อต่อ",
        addTo: "เพิ่มลงบนหน้าจอ",
        install: "ติดตั้งแอปพลิเคชันหรือไม่?",
        installNow: "ติดตั้ง",
        cancelInstall: "ยกเลิก",
        bookmark: "เพิ่มลงในบุ๊กมาร์ค",
        saveTitle: "บุ๊กมาร์ค",
        savePage1: 'คลิกที่ "ไอคอนดาว" บนแถบที่อยู่。',
        savePage2: "หรือ",
        savePage3: "Ctrl",
        savePage4: "เพื่อบันทึกหน้านี้ไว้。",
        checkLimit: "คุณได้ใช้โอกาสในการค้นหาสูงสุดที่จะได้ในวันนี้แล้ว กรุณาลองใหม่ในภายหลัง",
        reachedLimit: "สินค้านี้ได้ถึงขีดจำกัดการสั่งซื้อแล้ว กรุณารอสักครู่แล้วลองใหม่อีกครั้ง",
        unopened: "แอปพลิเคชันนี้ยังไม่เปิดใช้งานฟีเจอร์ชาร์จเงินตรงจากเว็บไซต์อย่างเป็นทางการ",
        createFailed: "การสร้างออเดอร์ของคุณล้มเหลว กรุณาลองใหม่อีกครั้ง",
        customerService: "บริการลูกค้า",
        FAQTitle: "常见问答",
        qtext1: "1.Mergeland-Alice's Adventure store是什么？",
        qtext2: "2.我该如何绑定账户以进行购买？我绑定账户时遇到了些问题。",
        qtext3: "3.Mergeland-Alice's Adventure store购买的商品需要多长时间才能出现在我的游戏中？",
        qtext41: "若您在Mergeland-Alice's Adventure store进行购买时遇到与账单有关的问题，请前往Facebook搜索Mergeland-Alice's Adventure，联系我们的官方客服处理。请确保提供有关您购买物品的以下信息，以便我们进行进一步的调查：",
        qtext42: "所购买物品的确切数量、进行购买的大概时间以、订单确认单号以及您的玩家ID/UID。",
        qtext43: "购买收据的截图或错误信息的截图，请勿提供付款提供商正在处理中的回执截图。",
        atext1: "Mergeland-Alice's Adventure store是《Mergeland-Alice's Adventure》游戏的官方在线市场",
        atext21: "欲在商店里进行购买，您必须先登录您的玩家账户。首先，请在您玩游戏的移动设备上使用默认浏览器来访问商店（不支持隐身/无痕模式。）",
        atext22: "点击页面“登录”按钮，或开始购买物品。这将打开您的游戏，然后它会自动返回到商店。登录完毕后，您将能够在商店页面看见您的用户名。",
        atext23: "若游戏没有自动返回到商店，那代表您的游戏应用可能仍是旧的版本，或游戏可能需要重启，又或是您的浏览器历史记录中可能保存了旧的cookie。 请确保您的游戏是最新版本；您可以在Play Store 或iOS App Store检查游戏是否有更新。 您也可以在浏览器的历史记录标签页中，清除您的浏览器历史记录。",
        atext24: "若您的游戏已是最新版本，那么请您关闭并重新打开游戏应用，进行重启。",
        atext25: "iOS设备：",
        atext26: "若要退出游戏，请打开App切换器，向右轻扫以找到游戏，然后再向上轻扫。",
        atext27: "若要重新打开该App，请前往主屏幕（或App资源库），然后轻点该App。",
        atext28: "Android设备：",
        atext29: "强行关闭游戏，然后重新打开。",
        atext3: "在Mergeland-Alice's Adventure store购买的商品应该会立即通过邮件发放到游戏中。若没有收到，可能需要重新启动游戏才会出现。",
        pendingPayment: "รอการชำระเงิน",
        paymentSoon: "กรุณาดำเนินการชำระเงินโดยเร็วที่สุด หากคุณชำระเงินเรียบร้อยแล้ว กรุณารอสักครู่และตรวจสอบในเกม",
        paymentComplete: "ชำระเงินเรียบร้อย",
        payAgain: "ซื้ออีกครั้ง",
        paymentSuccessfulOrderNotFound: "ไม่พบรายการออร์เดอร์ที่ชำระเงินสำเร็จในขณะนี้",
        OrderHasBeenSuccessfullyPaid: "ออร์เดอร์ได้รับการชำระเงินเรียบร้อยแล้ว",
        loginAgainToGift: "คุณไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบแล้วรับของขวัญอีกครั้ง",
        successfulClaim: "รับของขวัญสำเร็จแล้ว กรุณารอสักครู่และไปที่เมล์ในเกมเพื่อตรวจสอบ",
        freeGift: "ของขวัญฟรี",
        receiveGift: "รับของขวัญ",
        alreadyReceived: "คุณได้รับไปแล้ว โปรดอย่าทำซ้ำ",
        receiveError: "ไม่สามารถรับได้ กรุณาสอบถามกับเจ้าหน้าที่บริการลูกค้า",
        noNumber: "รูปแบบไม่ถูกต้อง กรุณาใส่ ID ที่เป็นตัวเลขเท่านั้น",
        tos: "นโยบายความเป็นส่วนตัว",
        term: "ฉันได้อ่านและตกลงตาม{0}",
        AddToHomeScreen: "เพิ่มลงบนหน้าจอหลัก",
        AddToHomeText1: "1.คลิกที่ปุ่มบนแถบเครื่องมือด้านล่าง",
        AddToHomeText2: "2.เลื่อนลงและเลือก “เพิ่มไปที่หน้าจอหลัก”",
        productHasExpired: "สินค้าหมดอายุแล้ว กรุณาซื้อสินค้าอื่น",
        BelowTheMinimum: "ขออภัย สินค้านี้มีมูลค่าต่ำกว่าขั้นต่ำที่กำหนดสำหรับวิธีการชำระเงิน กรุณาเลือกสินค้าอื่นๆ และลองอีกครั้ง",
        purchaseLimit: "ผลิตภัณฑ์ปัจจุบันของคุณเป็นผลิตภัณฑ์ที่มีจำนวนจำกัด เราพบคำสั่งซื้อที่ต้องชำระเงิน มันถูกสร้างขึ้นเมื่อ {limit} และจะหมดอายุหลังจากผ่านไป ",
        purchaseLimit3: " นาที โปรดดำเนินการชำระเงินให้เสร็จสิ้นโดยเร็วที่สุด",
        purchaseLimit2: "สินค้าที่คุณเลือกอยู่ในกลุ่มสินค้าจำกัดจำนวนการซื้อ มีการสั่งซื้อที่ยังไม่ชำระเงิน หลังจาก 30 นาทีจะหมดอายุ กรุณาชำระเงินให้เร็วที่สุด หากหมดอายุสามารถสั่งซื้อใหม่ได้ในภายหลัง",
        ok: "ตกลง",
        beforePurchasingAgain: "คุณแน่ใจหรือว่าต้องการยกเลิกการชำระเงินนี้? สินค้าปัจจุบันของคุณเป็นสินค้าที่ซื้อจำกัดเท่านั้น มีโอกาสซื้อเพียง {0} ครั้งเท่านั้น หากคุณยกเลิก คุณจำเป็นต้องรอ 30 นาทีก่อนซื้อใหม่อีกครั้งครับ/ค่ะ.",
        payNumber: "1",
        UIDLogin: "เข้าสู่ระบบด้วย ID ผู้ใช้",
        AccountLogin: "เข้าสู่ระบบด้วยบัญชี",
        TOPUP: "เติมเงิน",
        PointsShop: "ร้านคะแนน",
        PointsExchange: "แลกคะแนน",
        CurrentPoints: "คะแนนปัจจุบัน",
        ConsumptionHistory: "ประวัติการใช้",
        logInToParticipate: "ยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบเพื่อเข้าร่วมการแลกคะแนน",
        InsufficientPoints: "คะแนนไม่เพียงพอ ไม่สามารถแลกได้ในขณะนี้",
        ExchangeSuccessful: "การแลกเปลี่ยนสำเร็จ กรุณาตรวจสอบอีเมลในเกมของคุณภายหลัง",
        ensureTheSafety: "เพื่อรับรองความปลอดภัยของบัญชีของคุณและการเติมเงินสำเร็จของไอเท็มของคุณ โปรดคลิกที่ปุ่มด้านล่างเพื่อทำการยืนยันในเกมก่อน",
        GoVerify: "ไปยืนยัน",
        VerificationSuccessful: "การยืนยันสำเร็จ คุณสามารถเข้าร่วมในการแลกคะแนนได้แล้ว",
        VerificationFailed: "การยืนยันไม่สำเร็จ โปรดเข้าสู่บัญชีที่ถูกต้องและลองอีกครั้ง",
        Daily: "รายวัน",
        Weekly: "รายสัปดาห์",
        Monthly: "รายเดือน",
        Time: "เวลา",
        RedeemItems: "แลกไอเทม",
        ProductImage: "ภาพสินค้า",
        ProductName: "ชื่อสินค้า",
        RedeemQuantity: "จำนวนที่จะแลก",
        ConsumePoints: "ใช้คะแนน",
        NoDataTemporarily: "ไม่มีข้อมูลชั่วคราว",
        Game: "เกม",
        EnsureThatTheItems: "เพื่อให้แน่ใจว่าไอเท็มสามารถเติมเงินเข้าบัญชีของคุณได้อย่างประสบความสำเร็จ โปรดยืนยันระดับเกมล่าสุดของคุณ",
        GameLevel: "ระดับเกม",
        PleaseSelect: "โปรดเลือก",
        LevelError: "ข้อผิดพลาดในระดับ โปรดตรวจสอบในเกมและป้อนข้อมูลใหม่",
        TryAgainTomorrow: "ข้อผิดพลาดในระดับ โปรดลองอีกครั้งในวันพรุ่งนี้",
        RedeemNow: "แลกเปลี่ยนทันที",
        Confirm: "ยืนยัน",
        Back: "กลับ",
        ReturnToRedeem: "กลับไปแลกเปลี่ยน",
        EndlessTreasure: "สมบัติที่ไม่มีที่สิ้นสุด",
        Free: "ฟรี",
        PreviousStepFirst: "โปรดปลดล็อคขั้นตอนก่อนหน้านี้ก่อน",
        OperationSuccessful: "การดำเนินการสำเร็จ",
        YouWantToOverwrite: "บัญชีที่เข้าสู่เว็บไซต์ไม่ตรงกับในเกม โปรดยืนยันว่าคุณต้องการเขียนทับหรือไม่",
        QRCodeTip: 'เพื่อให้มั่นใจในความปลอดภัยของบัญชีของคุณ โปรดเข้าสู่ระบบโดยใช้บัญชี Facebook, Google หรือ Apple ของคุณ (ซึ่งต้องผูกไว้ในเกม) เพื่อให้สามารถเติม ไอเทม ลงบัญชีของคุณได้อย่างประสบความสำเร็จ หรือคัดลอกลิงก์ด้านล่างและเปิดในโทรศัพท์หรือใช้โทรศัพท์สแกน QR code และคลิกที่ "แลกทันที".',
        WebsiteLink: "ลิงก์เว็บไซต์:",
        PointsGift: "ของขวัญคะแนน",
        AccumulatedPoints: "คะแนนสะสม",
        AccumulatedPoints1: "คะแนน",
        FreeToClaim: "รับฟรี",
        AlreadyClaimed: "ได้รับแล้ว",
        ActivityRules: "กฎ",
        EventTime: "จัดกิจกรรมเวลา: 3 มิถุนายน 2024 - 13 มิถุนายน 2024 เวลา 23:59:59 (UTC+0)",
        EventTime6: "จัดกิจกรรมเวลา: ",
        EventTip1: "1. ระหว่างกิจกรรม, เติมเงินในร้านค้าอย่างเป็นทางการจะได้รับคะแนนที่เหมาะสม คะแนนที่ได้รับถึงจำนวนที่กำหนด จึงสามารถปลดล็อครางวัลที่แตกต่างกันได้ แต่ละผู้เล่นสามารถรับรางวัลแต่ละครั้งเท่านั้น",
        EventTip2: "2. คะแนนที่ได้รับสามารถใช้ปลดล็อครางวัลในระหว่างกิจกรรมเท่านั้น หลังจากสิ้นสุดกิจกรรม, คุณจะไม่สามารถรับรางวัลได้อีก",
        EventTip3: '3. กิจกรรมนี้เป็นสิทธิพิเศษที่ถูกมอบให้ คะแนนที่ได้รับไม่ขัดแย้งกับฟังก์ชัน "การแลกคะแนน" ด้านล่าง แทนการเติมเงินครั้งละครั้ง คุณจะได้รับคะแนนสองเท่า',
        EventTip4: "4. ให้แน่ใจว่ารางวัลสามารถเติมเข้าบัญชีของคุณได้อย่างราบรื่น แนะนำให้คุณเข้าสู่ระบบด้วยบัญชี Facebook, Google, Apple ที่ผูกมัดอยู่ในเกม",
        EventTip5: "5. คะแนนเป็นสิทธิพิเศษและไม่สามารถขอคืนเงินได้ หากคุณมีปัญหาใดๆ โปรดติดต่อเราผ่านทางช่องทางบริการลูกค้า",
        collectionsHasReachedTheLimit: "จำนวนการเรียกร้องมีขีดจำกัด",
        LimitedTimeWelfareActivities: "กิจกรรมสวัสดิการ",
        riskControlSystem: "พฤติกรรมของคุณได้ทำให้ระบบควบคุมความเสี่ยงทำงาน หากมีปัญหาโปรดติดต่อฝ่ายบริการลูกค้า ",
        GiftPack: "ชุดของขวัญ",
        EnterGiftRedemptionCode: "ป้อนรหัสของของขวัญ",
        Rules: "กฎ",
        TheGiftCodeHasExpired: "รหัสชุดของขวัญหมดอายุ",
        TheGiftCodeIncorrect: "รหัสชุดของขวัญไม่ถูกต้อง",
        ExchangeRules: "กติกาการแลก",
        ExchangeRules1: "1. รหัสการแลกสามารถใช้ได้เพียงครั้งเดียว มีอายุการใช้งานในระยะเวลาที่กำหนด โปรดใช้ในระยะเวลาที่กำหนด",
        ExchangeRules2: "2. โปรดตรวจสอบว่าคุณได้เข้าสู่ระบบบัญชีเกมของคุณในเว็บไซต์อย่างเป็นทางการเรียบร้อยแล้ว",
        ExchangeRules3: "3. เข้าสู่หน้าแลกของขวัญในเว็บไซต์อย่างเป็นทางการ ป้อนหรือวางรหัสการแลกที่คุณได้รับ จากนั้นคลิกส่ง",
        ExchangeRules4: "4. ระบบจะตรวจสอบความถูกต้องของรหัสการแลกโดยอัตโนมัติ หลังจากการแลกสำเร็จ โปรดตรวจสอบอีเมลและรับของขวัญในเกม",
        ExchangeRules5: "5. โปรดตรวจสอบว่ารหัสการแลกที่คุณป้อนถูกต้องและไม่มีข้อผิดพลาด เพื่อหลีกเลี่ยงการล้มเหลี่ยงในการแลกเนื่องจากข้อผิดพลาดในการป้อน",
        ExchangeRules6: "ขอให้คุณได้รับประสบการณ์การเล่นที่สนุกสนานในเกม! หากคุณมีคำถามหรือข้อสงสัยใด ๆ โปรดติดต่อฝ่ายสนับสนุนลูกค้าของเราได้ทุกเวลา ขอบคุณสำหรับการสนับสนุนและการเข้าร่วมของคุณ!",
        DiamondPackage: "แพ็คเกจเพชร",
        BenefitPackage: "แพ็คเกจสวัสดิการ",
        PointsShopTutorial: "บทแนะนำร้านคะแนน",
        PointsGivingRules: "กฎการให้คะแนน",
        PointsGivingRules1: "1. ระหว่างกิจกรรม โดยการเข้าสู่หน้าเติมเงินของเว็บไซต์อย่างเป็นทางการ คุณจะได้รับคะแนนหลังจากเติมเงิน",
        PointsGivingRules2: "2. จำนวนคะแนนที่ได้รับต่างกันขึ้นอยู่กับจำนวนเงินเติมเงิน คุณสามารถตรวจสอบจำนวนคะแนนที่คุณจะได้รับในส่วนโบนัสด้านล่างสินค้าก่อนที่จะเติมเงิน",
        PointsGivingRules3: "3. สินค้าที่ไม่ได้ระบุให้คะแนนหลังจากซื้อจะไม่ได้รับคะแนน",
        PointsExchangeTutorial: "คู่มือแลกคะแนน",
        PointsExchangeTutorial1: 'ขั้นตอนที่ 1: คลิกที่แท็บ "ร้านคะแนน" ที่ด้านล่างเพื่อเข้าสู่หน้าร้านคะแนน คุณยังสามารถคลิกที่ "ป๊อปอัปออกจากเว็บไซต์" หรือ "แบนเนอร์ด้านบน" เพื่อเข้าสู่;',
        PointsExchangeTutorial2: 'ขั้นตอนที่ 2: หากยังไม่ได้เข้าสู่ระบบ ควรใช้ Facebook, Google, Apple ที่ผูกกับเกม หรือคลิกที่ "เกม" เพื่อเข้าสู่ระบบโดยอัตโนมัติ;',
        PointsExchangeTutorial5: 'ขั้นตอนที่ 2: หากยังไม่ได้เข้าสู่ระบบ คลิกที่ "เกม" เพื่อเข้าสู่ระบบอัตโนมัติหรือใส่ UID เพื่อเข้าสู่ระบบ',
        PointsExchangeTutorial3: 'ขั้นตอนที่ 3: หากเข้าสู่ระบบแล้ว เลือกไอเท็มตาม "คะแนนปัจจุบัน" ในบัญชีของคุณ คลิกที่ "แลกเลย" เพื่อทำการแลกเปลี่ยน ในการแลกเปลี่ยนครั้งแรก อาจจะปรากฏ "ป๊อปอัปออกจากเว็บไซต์" คลิกที่ "ไปยืนยัน" ได้;',
        PointsExchangeTutorial4: "ขั้นตอนที่ 4: หลังจากการแลกเปลี่ยนสำเร็จ ไปที่เกม เช็คอีเมล์ของคุณและรับไอเท็มของคุณ.",
        PointUsageRules: "กฎการใช้คะแนน",
        PointUsageRules1: "1. คะแนนถูกผูกพันกับบัญชี ไม่สามารถโอน มอบให้ หรือถอนได้",
        PointUsageRules2: "2. คะแนนเป็นสิทธิพิเศษของการเติมเงินในเว็บไซต์อย่างเป็นทางการเท่านั้น ไม่มีการให้คะแนนเมื่อเติมเงินในเกมและไม่สามารถใช้คะแนนในเกม",
        Announcement: "ประกาศ",
        Announcement1: "1. เราจะอัพเดทไอเทมสำหรับแลกเปลี่ยนเป็นระยะๆ มาก่อนไปก่อนได้~",
        Announcement2: "2. ข้อจำกัดในการแลกเปลี่ยนไอเทมจะรีเซ็ตในวันแรกของรอบถัดไป (UTC+0)",
        Announcement3: "3. หากคุณได้รับจำนวนการแลกเปลี่ยนสูงสุดในสัปดาห์/เดือนนี้แล้ว โปรดเข้าร่วมกิจกรรมแลกเปลี่ยนในสัปดาห์/เดือนถัดไปต่อไป.",
        Redeem: "แลกเปลี่ยน",
        GiftCode: "รหัสของขวัญ",
        CollectionSuccessful: "รับสำเร็จแล้ว กรุณารอสักครู่แล้วไปตรวจสอบอีเมลในเกม",
        CollectionSuccessful2: "🎉กิจกรรมเว็บไซต์อย่างเป็นทางการเปิดแล้ว รีบไปที่ศูนย์สวัสดิการเพื่อรับรางวัล ข้อเสนอจำกัดเวลาให้ 10%-200% และยังมีของรางวัลใหญ่อย่างสกินที่กำหนดเองจากเว็บไซต์อย่างเป็นทางการ",
        JoinNow: "เข้าร่วมทันที",
        PremiumCenter: "ศูนย์พรีเมี่ยม",
        DesktopShortcut: "ทางลัด",
        AddDesktopOpen: "เพิ่มไปยังดสก์ทอปและเปิด",
        LoginReward: "เข้าสู่ระบบ",
        LogTOPCenter: "เข้าสู่ระบบที่ศูนย์เติมเงิน",
        FirstPurchase: "การซื้อครั้งแรก",
        CompleteTheFirstPurchase: "ทำการซื้อครั้งแรกเสร็จสมบูรณ์",
        ClaimNow: "เรียกร้องทันที",
        COMPLETE: "เสร็จสมบูรณ์",
        DailyCheckIn: "การเช็คอินประจำวัน",
        Day: "วันที่ {day}",
        CheckIn: "เช็คอิน",
        Note: "หมายเหตุ: หากคุณเช็คอินเป็นระยะเวลา 7 วันติดต่อกัน คุณจะเริ่มต้นใหม่จากวันที่ 1 อีกครั้ง",
        TotalCheckIns: "จำนวนการเช็คอินทั้งหมด",
        Days: " วัน",
        CheckCeceive: "เช็คอินเป็นเวลา {0} วันเพื่อรับ",
        CheckedForDays: "เช็คอินไปแล้ว {0} วัน: ",
        OneClickReceive: "รับสินค้าด้วยคลิกเดียว",
        PleaseTomorrow: "กรุณามารับสินค้าพรุ่งนี้",
        PurchaseGift: "ของขวัญเติมเงิน",
        AccumulatedPurchase: "ยอดเติมเงินรวม",
        InsufficientReward: "จำนวนเงินไม่เพียงพอไม่สามารถรับรางวัลได้",
        EventPeriod: "เวลากิจกรรม: ",
        EventPeriod1: "1. ระหว่างกิจกรรม, การเติมเงินรวมทั้งในร้านค้าอย่างเป็นทางการ ถึงจำนวนเงินที่กำหนดจะสามารถปลดล็อครางวัลได้ ผู้เล่นแต่ละคนสามารถรับรางวัลแต่ละรางวัลได้เพียงครั้งเดียว",
        EventPeriod2: "2. คุณต้องเข้าสู่ระบบบัญชีและตรวจสอบ ID เกมเพื่อดูความก้าวหน้าของกิจกรรมและรับรางวัล",
        EventPeriod3: "3. เมื่อกิจกรรมจบลง คุณจะไม่สามารถรับรางวัลได้อีก และงานที่เกี่ยวข้องก็จะไม่สามารถเสร็จสิ้นได้อีก",
        Events: "เหตุการณ์",
        redeemedAll: "คุณได้แลกทั้งหมดแล้ว โปรดมาใหม่ในรอบต่อไป",
        reconnectNetwork: "คุณอยู่ในสถานะออฟไลน์ กรุณาเชื่อมต่ออินเทอร์เน็ตอีกครั้ง",
        Recharge: "เติมเงิน",
        Receive: "รับฟรี",
        Completed: "เสร็จแล้ว",
        PurchaseReward: "รางวัลการซื้อ",
        GetFreeSkin: "รับสกินฟรี",
        CurrentlyNoActivities: "ขณะนี้ยังไม่มีกิจกรรม",
        EventsTips: "เฉพาะการเติมเงินที่ศูนย์เว็บไซต์ทางการเท่านั้นที่จะนับไปสู่งาน"
    },
    Mergeland: {
        text1: 'กลับมาสัมผัสเรื่องราวและความทรงจำของโลกมหัศจรรย์ในเกมที่ได้รับแรงบันดาลใจจากนิทานคลาสสิกอย่าง "อลิซในแดนมหัศจรรย์" และ "ผ่านกระจกไปยังโลกมหัศจรรย์" ด้วยการดัดแปลงโครงเรื่องที่เป็นเอกลักษณ์ ฉากและตัวละครคลาสสิกของโลกสวรรค์ลึกลับถูกกลับมาถ่ายทอดอีกครั้ง',
        text12: "ที่นี่ คุณสามารถตามกระแสเท้าของ Ally สาวน้อย ผ่านมิติข้ามไปยังโลกมหัศจรรย์ที่น่าอัศจรรย์ ช่วยเหลือตัวละครอย่างกระต่ายขาว และหมวกบ้า และทำให้โลกสวรรค์กลับคืนสู่สภาพเดิม",
        text2: "ไฮไลท์ของเกม",
        text3: "โลกของนิทานเวทมนตร์ที่เต็มไปด้วยเสน่ห์ ตั้งแต่ทุ่งหญ้าที่สดใส ป่าไม้ลึกลับ ไปจนถึงวังที่วิจิตรงดงาม ภายใต้การออกแบบของศิลปินของเรา ฉากนิทานคลาสสิกต่างๆ ถูกนำเสนอตรงหน้าผู้เล่น โดยรายละเอียดที่ประณีตและสวยงามจัดจ้านที่พบทุกหนทุกแห่งนำมาซึ่งประสบการณ์ทางสายตาที่ยิ่งใหญ่และไม่เคยมีมาก่อน",
        text4: "การผสานการเล่นแบบรวมเข้าด้วยกันและการเล่นแบบซ่อมแซมฉาก, ทำให้ผู้เล่นสามารถนำองค์ประกอบที่รวมกันได้ทุกชิ้นมาใช้เป็นวัสดุในการซ่อมแซมดินแดนแห่งความฝัน, เมื่อระดับขององค์ประกอบเพิ่มขึ้น, ดินแดนที่พังทลายนั้นก็จะค่อยๆ กลับคืนสู่สภาพเดิมและแสดงให้ผู้เล่นเห็นอย่างทีละขั้นตอน",
        text5: 'กิจกรรมและฉากเทศกาลที่หลากหลายช่วยให้ผู้เล่นไม่เพียงได้สัมผัสกับนิทานคลาสสิคเช่น "ซินเดอเรลล่า" หรือ "เจ้าหญิงนิทรา" เท่านั้น แต่ยังสามารถได้รับสกินของตัวละคร/ไอเท็มสำหรับการซ่อมแซมด้วยการทำภารกิจและท้าทายในกิจกรรมต่างๆ และตกแต่งดินแดนแห่งเทพนิยายที่เป็นเอกลักษณ์ของตัวเองได'
    },
}